import { fieldConfig } from "@autoform/zod";
import { z } from "zod";

import { Media } from "@/components/forms/schemas/media";

const NAME_REQUIRED = "A group needs a name.";

/**
 * The create and edit form for a Mood event group. `Media` requires one photo; `teasers` is
 * extended with a `[]` default because the base schema has none, and a missing key would fail
 * validation on a field the curator never sees.
 */
export const eventGroupFormSchema = z.object({
  /** Hidden: the storage path id the photos are uploaded under. On edit it is the group's own id. */
  id: z.string().superRefine(fieldConfig({ fieldType: "hidden" })),
  // A name left blank never reaches `min`: the form drops empty values, so it arrives missing.
  name: z
    .string({ required_error: NAME_REQUIRED })
    .trim()
    .min(1, NAME_REQUIRED),
  about: z
    .string()
    .optional()
    .superRefine(fieldConfig({ fieldType: "textarea" })),
  media: Media.extend({ teasers: Media.shape.teasers.default([]) }).superRefine(
    fieldConfig({
      fieldType: "media",
      customData: { collection: "EventGroups" },
    }),
  ),
});

export type EventGroupFormType = z.infer<typeof eventGroupFormSchema>;
